import React from "react";
import {
  Wrapper,
  Card,
  CardBody,
  Title,
  Copy
} from "app/NativeComponents/common";
import { MenuItem } from "app/NativeComponents/snippets";

import { toTitleCase } from "app/DealMachineCore/actions";

const BillingOptions = ({ user, colors, appRedirect, platform }) => {
  const renderTeamInfo = () => {
    if (user.team_clearance_level == 0) {
      return (
        <Card>
          <CardBody>
            <Title>Your Team Leader's Contact Information</Title>
            <Copy>{toTitleCase(user.team_name)}</Copy>
            <Copy>{user.team_phone}</Copy>
            <Copy>{user.team_email}</Copy>
          </CardBody>
        </Card>
      );
    }
  };

  if (user.team_owner == 1 || user.team_clearance_level > 1) {
    return (
      <Card>
        <MenuItem
          style={{
            borderBottomWidth: 1,
            borderBottomColor: colors.border_color,
            borderBottomStyle: "solid"
          }}
          to="/a/settings/billing"
          onPress={() => appRedirect({ redirect: "billing" })}
          title="Manage your account and view spend reports"
          text={"Manage your account"}
        />
      </Card>
    );
  }

  return <Wrapper>{renderTeamInfo()}</Wrapper>;
};

export default BillingOptions;
